import React from "react";
import { getBezierPath, useInternalNode, BaseEdge } from "@xyflow/react";
import { getEdgeParams } from "./getEdgeParams";

function FloatingEdge({
    id,
    source,
    target,
    markerEnd,
    markerStart,
    style,

    // ✅ przychodzą z edge obiektu
    label,
    labelBgPadding,
    labelBgBorderRadius,
    labelBgStyle,
}) {
    const sourceNode = useInternalNode(source);
    const targetNode = useInternalNode(target);

    if (!sourceNode || !targetNode) return null;

    const { sx, sy, tx, ty, sourcePos, targetPos } = getEdgeParams(sourceNode, targetNode);

    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX: sx,
        sourceY: sy,
        sourcePosition: sourcePos,
        targetPosition: targetPos,
        targetX: tx,
        targetY: ty,
    });

    return (
        <BaseEdge
            id={id}
            path={edgePath}
            markerEnd={markerEnd}
            markerStart={markerStart}
            style={style}
            // ✅ label
            label={label}
            labelX={labelX}
            labelY={labelY}
            // ✅ tło labela jak u Ciebie w onConnect
            labelShowBg={!!label}
            labelBgPadding={labelBgPadding ?? [6, 3]}
            labelBgBorderRadius={labelBgBorderRadius ?? 4}
            labelBgStyle={labelBgStyle ?? { fill: "white", fillOpacity: 0.8 }}
        />
    );
}

export default FloatingEdge;
